/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Lock: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12 0C8.7 0 6 2.7 6 6V7.5H3C2.1 7.5 1.5 8.1 1.5 9V22.5C1.5 23.4 2.1 24 3 24H21C21.9 24 22.5 23.4 22.5 22.5V9C22.5 8.1 21.9 7.5 21 7.5H18V6C18 2.7 15.3 0 12 0ZM13.5 17.55V19.5H10.5V17.55C9.6 17.1 9 16.05 9 15C9 13.35 10.35 12 12 12C13.65 12 15 13.35 15 15C15 16.05 14.4 17.1 13.5 17.55ZM15 7.5H9V6C9 4.35 10.35 3 12 3C13.65 3 15 4.35 15 6V7.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
